import { Product } from "components/commons";
import styles from "../order-summary.module.scss";
import Big from "big.js";
import { formatAmount, stringToDecimal } from "utils/text.utils";
import { prettifyProductCode } from "utils/pretty.utils";
import { formatVolume } from "utils";
import { ProductCodeEnum } from "enums";
import { InputAmount } from "components/field";
import UnitPill from "../../components/unit-pill";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import TooltipBubble from "components/commons/tooltip/tooltip-bubble.module";
import { locale } from "localization/en";

export const setVariance = ({
  quantityBeforeReceivingNumber = 0,
  quantityDeliveredNumber = 0,
  quantityAfterReceivingNumber = 0,
}) => {
  quantityBeforeReceivingNumber = stringToDecimal(quantityBeforeReceivingNumber || 0);
  quantityDeliveredNumber = stringToDecimal(quantityDeliveredNumber || 0);
  quantityAfterReceivingNumber = stringToDecimal(quantityAfterReceivingNumber || 0);

  return Big(quantityAfterReceivingNumber)
    .minus(Big(quantityBeforeReceivingNumber).add(quantityDeliveredNumber))
    .toNumber();
};

export const getQuantityAfterReceiving = (quantityBeforeReceiving, quantityDelivered) => {
  quantityBeforeReceiving = stringToDecimal(quantityBeforeReceiving || 0);
  quantityDelivered = stringToDecimal(quantityDelivered || 0);

  return Big(quantityBeforeReceiving).plus(quantityDelivered);
};

export const mapDataToOrderItems = ({ orderItem, fieldsAsRows, modifyField, modifyForm }) => {
  const item = orderItem;
  const matchIndex = (fieldsAsRows || []).findIndex((row) => {
    return row?.orderItemId?.value === orderItem?.orderItemId;
  });

  const index = matchIndex === -1 ? 0 : matchIndex;
  const rowFields = fieldsAsRows?.[index] ?? {};

  return {
    product: (
      <div className={styles.content}>
        <Product
          key={item?.productCode}
          grass={item?.productCode === ProductCodeEnum.GAS91}
          salsa={item?.productCode === ProductCodeEnum.GAS95}
          deepBlue={item?.productCode === ProductCodeEnum.GAS97}
          cheddar={item?.productCode === ProductCodeEnum.DIESEL}
        >
          {prettifyProductCode(item?.productCode)}
        </Product>
      </div>
    ),
    currentInventoryLevel: (
      <div className={styles.inputRow}>
        <UnitPill value={formatVolume(item?.inventoryLevelCm, "")} unit="cm" />
        <div
          style={{
            paddingTop: "10px",
          }}
        >
          /
        </div>
        <UnitPill value={formatVolume(item?.inventoryLevelLiter, "")} unit="L" />
        {item?.isInventoryFromTotalizer && (
          <TooltipBubble content={locale.currentInventoryLevelInfo} disabled={false}>
            <InfoOutlinedIcon className={styles.infoicon} />
          </TooltipBubble>
        )}
      </div>
    ),
    orderVolume: <div className={styles.content}>{formatVolume(item?.volume ?? 0)}</div>,
    amountInPhp: (
      <div className={styles.productField}>
        <InputAmount
          {...rowFields.amount}
          onChange={modifyField}
          required
          innerLabel={true}
          className={styles.amount}
        />
      </div>
    ),
  };
};

export const mapDataToListViewFuel = ({ orders }) => {
  const productCode = orders?.productCode;
  const inventoryLevelCm = orders?.inventoryLevelCm;
  const inventoryLevelLiter = orders?.inventoryLevelLiter;
  const volume = orders?.volume;
  const item = orders?.orderItems;

  return {
    product: (
      <div style={{ margin: "10px 0px" }}>
        <Product
          key={productCode}
          grass={productCode === ProductCodeEnum.GAS91}
          salsa={productCode === ProductCodeEnum.GAS95}
          deepBlue={productCode === ProductCodeEnum.GAS97}
          cheddar={productCode === ProductCodeEnum.DIESEL}
        >
          {prettifyProductCode(productCode)}
        </Product>
      </div>
    ),
    pumpPrice: formatAmount(orders?.pumpPrice) ?? "-", //TODO: (ger) update when value is available
    currentInventoryLevel: (
      <div className={styles.inputRow}>
        <UnitPill value={formatVolume(inventoryLevelCm, "")} unit="cm" />
        <div
          style={{
            paddingTop: "10px",
          }}
        >
          /
        </div>
        <UnitPill value={formatVolume(inventoryLevelLiter, "")} unit="L" />
        {item?.isInventoryFromTotalizer && (
          <TooltipBubble content={locale.currentInventoryLevelInfo} disabled={false}>
            <InfoOutlinedIcon className={styles.infoicon} />
          </TooltipBubble>
        )}
      </div>
    ),
    orderVolume: formatVolume(volume),
    amountInPhp: orders?.amount === 0 ? "-" : formatAmount(orders?.amount),
  };
};
